var EventEmitter = require('events');

function BrowserTransport(Spin) {
  this.constructor();
  this.Spin = Spin;
}

BrowserTransport.prototype = new EventEmitter();
BrowserTransport.prototype.constructor = EventEmitter;

BrowserTransport.prototype.data = function (data) {
  // console.log('onStoreUpdate', data);
  if (data.store) {
    // console.log('transport store', data.store);
    for (var id in data.store) {
      // console.log('on store', id, data.store[id]);
      this.add(data.store[id]);
    } //this.emit('spin-connected', spin);

  } else if (data.created) {
    // console.log('transport created', data.id, data.created);
    this.add(data.created);
  } else if (data.update) {
    if (data.id in this.Spin.spinIds) {
      // console.log('transport update', data.id);
      this.update(data.id, data.update); //Spin.store.set();
    } else {
      console.log('transport postcreate', data.id);
      data.update.id = data.id;
      this.add(data.update); // this.add(data);
    }
  } else if (data.destroyed) {// console.log('transport created', data.id, data.created);
  }
};

BrowserTransport.prototype.update = function (id, changes) {
  console.log('transport update', id, changes);
  var spin = this.Spin.spinIds[id]; // var changed = spin.setState(changes);
  // if (!changed) {
  // 	console.log('no changes');
  // 	return;
  // }

  for (var c in changes) {
    spin.state[c] = changes[c];
  } // console.log('update changed', changed);


  if ('knobPushed' in changes) {
    spin.emit('knob', changes.knobPushed);
  }

  if ('buttonPushed' in changes) {
    // console.log('emit button pushed', spin.state.id, changes.buttonPushed);
    spin.emit('button', changes.buttonPushed);
  }

  if ('spinPosition' in changes) {
    // let diff;
    // let throttled = false;
    // if (spin._lastSpinPosition !== undefined) {
    // 	diff = spin.state.spinPosition - spin._lastSpinPosition;
    // 	if (Math.abs(diff) > 1) {
    // 		throttled = true;
    // 		while (spin._lastSpinPosition !== spin.state.spinPosition) {
    // 			console.log('skipping from', spin._lastSpinPosition, 'to', spin.state.spinPosition);
    // 			spin._lastSpinPosition += diff>0? 1 : -1;
    // 			spin.emit('spin', spin.state.spinDirection, spin._lastSpinPosition);
    // 		}
    // 	}
    // }
    // if (!throttled) {
    // 	console.log('SPIN not throttled', spin.state.spinPosition);
    // 	spin._lastSpinPosition = spin.state.spinPosition;
    // 	spin.emit('spin', spin.state.spinDirection, spin.state.spinPosition);
    // }
    spin._lastSpinPosition = spin.state.spinPosition; // TODO: connected gets set to false upon reconnections
    // if (spin.state.connected) {
    // 	console.log('emit connected', spin.state.spinPosition);

    spin.emit('spin', spin.state.spinDirection, spin.state.spinPosition); // }
    // else {
    // 	console.log('not connected?', spin.state.connected);
    // }
    // if (spin._lastSpinPosition === undefined) {
    // 	console.log('first _lastSpinPosition', spin.state.spinPosition);
    // 	debugger;
    // }
    // else {
    // }
    // this.emit('update', spin.state);
  }

  if ('connected' in changes) {
    if (changes.connected) {
      this.emit('spin-connected', spin);
      spin.emit('connect');
    } else {
      this.emit('spin-disconnected', spin);
      spin.emit('disconnect');
    }
  }

  console.log('update', changes);
  spin.emit('update', changes); // spin.on('update', function(changes) {
  // 	console.log('on update', changes);
  // });
};

BrowserTransport.prototype.add = function (state) {
  if (state.id in this.Spin.spinIds) {
    // console.log('already added', state.id);
    this.update(state.id, state);
    return;
  }

  var spin = this.Spin.create(state, this);
  this.emit('spin-created', spin); // if ('knobPushed' in data) {
  // 	spin.processKnob(data['knobPushed']);
  // }
  // if ('buttonPushed' in data) {
  // 	spin.processButton(data['buttonPushed']);
  // }
  // var me = this;
  // if (spin.state.connected) {
  // 	// me.emit('spin-created', spin);
  // }
  // else {
  // 	spin.once('connect', function() {
  // 		me.emit('spin-connected', spin);
  // 	});
  // }
};

BrowserTransport.prototype.remove = function (data) {};

BrowserTransport.prototype.sendCommand = function (spin, args) {
  // this.emit('command', spin, args);
  console.log('BrowserTransport sendCommand', spin.id, args);
  var id = args.shift();
  var method = args.shift();
  console.log('args', args); //debugger;

  this.postCommandFn({
    spinCommand: {
      id: id,
      method: method,
      args: args
    }
  });
};

BrowserTransport.prototype.setPostCommand = function (fn) {
  this.postCommandFn = fn;
};

export default BrowserTransport;